module.exports = __webpack_public_path__ + "static/media/focus-the-abcd-method-technique-it.85304b72.md";


//////////////////
// WEBPACK FOOTER
// ./src/data/playbooks/focus-the-abcd-method-technique-it.md
// module id = 496
// module chunks = 18